;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';
import { z } from 'zod';

export const LATIN_ERROR = 'Only Latin characters are allowed';

/** Tests whether a string contains any non-ASCII (non-Latin) character. */
function hasNonLatin(value: string): boolean {
  return /[^\x20-\x7E]/.test(value);
}

/** Strips all non-ASCII characters from a string. */
export function stripNonLatin(value: string): string {
  return value.replace(/[^\x20-\x7E]/g, '');
}

/**
 * Returns an onChange handler that strips non-ASCII characters from the input.
 */
export function makeLatinOnlyChange(
  onFieldChange: (value: string) => void
): React.ChangeEventHandler<HTMLInputElement> {
  return (e) => onFieldChange(stripNonLatin(e.target.value));
}

/**
 * Zod superRefine helper that adds validation issues for fields containing
 * non-Latin characters. Call this inside createFormSchema's superRefine
 * for the relevant field list.
 */
export function addLatinOnlyIssues(
  data: Record<string, unknown>,
  ctx: z.RefinementCtx,
  fields: string[]
): void {
  for (const field of fields) {
    const value = data[field];
    if (typeof value === 'string' && hasNonLatin(value)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [field],
        message: LATIN_ERROR,
      });
    }
  }
}

const CYRILLIC_TO_LATIN: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  ґ: 'g',
  д: 'd',
  ђ: 'dj',
  ѓ: 'gj',
  е: 'e',
  ё: 'yo',
  є: 'ye',
  ж: 'zh',
  з: 'z',
  ѕ: 'dz',
  и: 'i',
  і: 'i',
  ї: 'yi',
  й: 'y',
  ј: 'j',
  к: 'k',
  л: 'l',
  љ: 'lj',
  м: 'm',
  н: 'n',
  њ: 'nj',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  ћ: 'c',
  ќ: 'kj',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'ts',
  ч: 'ch',
  џ: 'dzh',
  ш: 'sh',
  щ: 'sht',
  ъ: 'a',
  ы: 'y',
  ь: 'y',
  э: 'e',
  ю: 'yu',
  я: 'ya',
};

/** Transliterates Cyrillic letters to Latin (Старозагорска област -> Starozagorska oblast). */
export function transliterateCyrillic(value: string | undefined): string {
  return (value ?? '').replace(/[Ѐ-ӿ]/g, (char) => {
    const latin = CYRILLIC_TO_LATIN[char.toLowerCase()];
    if (latin === undefined) return char;
    return char === char.toLowerCase() ? latin : latin.charAt(0).toUpperCase() + latin.slice(1);
  });
}
